// BM-H3516 (3 Oct 2026, Accounts, agreed by Vanessa): only OTC and OTS are
// transfers between the firm's own accounts. CTO ("Client to Other") pays
// someone from client account, so it takes the payee fields and the AML
// Policy §10.2 bank details check. Mirrors backend hub/payment_type_taxonomy.py.
export const INTER_ACCOUNT_TYPES = ["OTC", "OTS"];

export function isInterAccount(paymentType) {
  return INTER_ACCOUNT_TYPES.includes((paymentType || "").trim());
}

// CTO requests made before BM-H3516 were saved as transfers (source and
// destination, no payee), so they keep the transfer layout on display.
export function showsTransferFields(paymentType, data) {
  if (isInterAccount(paymentType)) return true;
  const d = data || {};
  return (paymentType || "").trim() === "CTO" && !!d.source_account && !d.payee_name;
}
